module.exports = __webpack_public_path__ + "static/media/34-5.b1ee09e4.mp3";